import 'react-phone-input-2/lib/style.css';
import { COUNTRIES_LIST } from '@quadminds/shared/commons';
import { RefObject } from 'react';
import ReactPhoneInput, { CountryData } from 'react-phone-input-2';
import { twMerge } from 'tailwind-merge';
import { inputSize, inputStyle } from '../input/input'; // Esta casado con input
import Text from '../text/text';
/* eslint-disable-next-line */

export interface PhoneInputProps {
    ref?: RefObject<HTMLInputElement>;
    id: string;
    name: string;
    label?: string;
    placeholder?: string;
    filterByCode?: string[];
    defaultCountry?: string;
    value: string | undefined;
    onChange: (value: string) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>, data: Record<string, unknown> | CountryData) => void;
    error?: boolean | undefined | '';
    errorMessage?: string;
    completed?: boolean;
    disabled?: boolean;
    rounded: 'standard' | 'full';
    classNameInput?: string;
    classNamePhonePrefix?: string;
    classNameContainer?: string;
    required?: boolean;
    size?: inputSize;
    style?: inputStyle;
    readonly?: boolean;
    onlyCountries?: string[];
    preferredCountries?: string[];
    enableSearch?: boolean;
    'data-testid'?: string;
    'data-test-id'?: string;
}

export function PhoneInput(props: PhoneInputProps) {
    const paddingBase = {
        sm: 'p-1',
        md: 'p-sm',
        lg: 'p-3',
    };

    const stylesColors = {
        primary: 'focus:border-primary-500',
        variant: 'focus:border-variant-800',
    };

    const classes = twMerge(
        '!w-full pl-[45px] outline-none border text-sm placeholder-gray-300',
        props.completed ? 'text-black' : 'text-stone-500',
        paddingBase[props.size || 'md'],
        props.rounded === 'standard' ? 'rounded' : 'rounded-full',
        !props.error && 'border-gray-100 hover:border-zinc-500 active:border-zinc-500',
        stylesColors[props.style || 'primary'],
        props.error && '!border-error-200 hover:!border-error-200 active:!border-error-200 focus:!border-error-200',
        props.disabled &&
            'border-gray-50 hover:border-gray-50 active:border-gray-50 focus:border-gray-50 bg-gray-50 !cursor-default',
        props.classNameInput,
    );

    return (
        <div className={props.classNameContainer}>
            <div className="flex">
                {props.label && (
                    <Text element="label" lineHeight="24" weight="medium" htmlFor={props.id}>
                        {props.label}
                    </Text>
                )}
                {props.required && <span className="text-red-600">&nbsp; * </span>}
            </div>
            <ReactPhoneInput
                onlyCountries={props.onlyCountries ?? []}
                preferredCountries={props.preferredCountries ?? COUNTRIES_LIST}
                country={props.defaultCountry ? props.defaultCountry : props.disabled ? '' : 'ar'}
                onChange={props.onChange}
                onBlur={(event, data) => {
                    props.onBlur && props.onBlur(event, data);
                }}
                value={props.value}
                inputProps={{
                    id: props.id,
                    name: props.name,
                    required: props.required || false,
                    readOnly: props.readonly || props.disabled,
                    className: classes,
                    disabled: props.disabled || props.readonly,
                }}
                inputClass={twMerge(props.disabled && '!cursor-default', '', props.classNamePhonePrefix)}
                placeholder={props.disabled ? '' : props.placeholder}
                disabled={props.disabled}
                disableDropdown={props.disabled}
                autocompleteSearch={false}
                enableSearch={props.enableSearch ?? false}
                data-testid={props['data-testid'] || `${props.name}-phone`}
                data-test-id={props['data-test-id'] || `${props.name}-phone`}
            />
            {props.error && <p className="text-red-500 text-xs mt-2">{props.errorMessage}</p>}
        </div>
    );
}
PhoneInput.defaultProps = {
    error: false,
    rounded: 'standard',
    style: 'primary',
};

export default PhoneInput;
